import { useEffect } from "react";
import { useNavigate } from "react-router";
import { useCurrentUser } from "@/features/login/hooks/useCurrentUser";

export function ForceLogoutPage() {
  const { logout: clearUser } = useCurrentUser();
  const navigate = useNavigate();

  useEffect(() => {
    clearUser();
    navigate("/login", { replace: true });
  }, []);

  return null;
}
